// Gateway states
import { gateway, gatewayConfig } from './gateway.js'

export default function gatewayRoutes($stateProvider) {
  'ngInject'
  $stateProvider.state(gateway, gatewayConfig)
}
